<template>
  <Teleport to="body">
    <Transition name="qv" appear>
      <div class="qv-overlay" @click.self="$emit('close')">
        <div class="qv-panel" role="dialog" aria-modal="true" :aria-label="ariaLabel">
          <button type="button" class="qv-close" @click="$emit('close')" aria-label="Закрыть">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div class="qv-body">
            <slot />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
defineProps({
  ariaLabel: { type: String, default: '' },
})
const emit = defineEmits(['close'])

function onKeydown(e) {
  if (e.key === 'Escape') emit('close')
}

onMounted(() => {
  document.addEventListener('keydown', onKeydown)
  document.body.classList.add('qv-lock')
})
onUnmounted(() => {
  document.removeEventListener('keydown', onKeydown)
  document.body.classList.remove('qv-lock')
})
</script>

<style scoped>
.qv-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 13, 12, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  overflow-y: auto;
}

.qv-panel {
  position: relative;
  width: 100%;
  max-width: 104rem;
  max-height: 88vh;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.qv-close {
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  width: 3.8rem;
  height: 3.8rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  border: none;
  color: #1b1918;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  transition: background 0.2s;
}
.qv-close:hover {
  background: #fff;
}

.qv-body {
  width: 100%;
  max-height: 88vh;
  overflow-y: auto;
}

/* ─── Transition: desktop fade + scale ───────────────────────────────── */
.qv-enter-active,
.qv-leave-active {
  transition: opacity 0.25s ease;
}
.qv-enter-active .qv-panel,
.qv-leave-active .qv-panel {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.qv-enter-from,
.qv-leave-to {
  opacity: 0;
}
.qv-enter-from .qv-panel,
.qv-leave-to .qv-panel {
  transform: scale(0.96) translateY(8px);
  opacity: 0;
}

/* ─── Mobile: bottom sheet ─────────────────────────────────────────────
   Inset on every side (not edge-to-edge) so the dimmed page stays visible
   all around — it reads as a floating card over content, not a full-width
   dock, which is the whole point of a "there's more behind this" sheet. */
@media (max-width: 48em) {
  .qv-overlay {
    align-items: flex-end;
    justify-content: center;
    padding: 0 0 2rem;
  }
  .qv-panel {
    width: 88%;
    max-width: 88%;
    max-height: 82vh;
    border-radius: 16px;
  }
  .qv-body {
    max-height: 82vh;
  }
  .qv-enter-from .qv-panel,
  .qv-leave-to .qv-panel {
    transform: translateY(100%);
  }
}
</style>

<style>
body.qv-lock {
  overflow: hidden;
}
</style>
